<div class="modal-header" ngxModalDraggable>
  <h4 class="modal-title">{{key}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="bsModalRef.dismiss()">
  </button>
</div>
<div class="modal-body bg-light">
  <form>
    <ng-container *transloco="let t; read: 'ime.common.localizations'">
      <mes-api-response-summary class="d-none" [response]="response"></mes-api-response-summary>
      <div class="card">
        <div class="card-body">
          <h5 class="card-title pb-1">{{t('Translations')}}</h5>
          <div class="form-group row" *ngFor="let localization of localizations">
            <label for="value-{{localization.Id}}" class="col-sm-4 col-form-label">
              {{(languagesQuery.getAll$ | async | find: 'Id': localization.LanguageId)?.Code}}
            </label>
            <div class="col-sm-8">
              <input type="text" class="form-control" id="value-{{localization.Id}}" name="value-{{localization.Id}}" [(ngModel)]="localization.Value">
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</div>
<mes-web-edit-modal-buttons [entityId]="key"
                            [hasDeleteButton]="false"
                            [isPristine]="isPristine$ | async"
                            (saveClick)="save($event)"
                            (cancelClick)="bsModalRef.dismiss()">
</mes-web-edit-modal-buttons>
